



































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { BaseDocument } from "@/services/datatypes";
import { DialogProgrammatic as Dialog } from "buefy";
import { firestore } from "@/scripts/firebase";

@Component
export default class EditableTitle extends Vue {
  title = "abc";
  editMode = false;
  @Prop() document!: BaseDocument;
  @Prop() refDocument!: firebase.firestore.DocumentReference;
  mounted() {
    this.title = this.document.title;
  }
  get isOwner() {
    return (
      this.$store.state.firebaseUser &&
      this.document.owner === this.$store.state.firebaseUser.uid
    );
  }
  get isChanged() {
    return this.title !== this.document.title;
  }
  handleEdit() {
    this.editMode = true;
  }
  handleSave() {
    this.refDocument.update({
      title: this.title
    });
    this.document.title = this.title;
    this.editMode = false;
  }
  handleCancel() {
    this.title = this.document.title;
    this.editMode = false;
  }

  handleDelete(playerId: string) {
    Dialog.confirm({
      message: `「${this.document.title}」を削除しますか。ランキングや戦歴の情報は削除されません。`,
      type: "is-danger",
      cancelText: "キャンセル",
      confirmText: "削除する",
      onConfirm: async () => this.deleteJinroRoom()
    });
  }

  async deleteJinroRoom() {
    await this.refDocument.set(
      {
        isDeleted: true,
        timeUpdated: firestore.FieldValue.serverTimestamp()
      },
      { merge: true }
    );
    this.$router.push("/j");
  }
}
